import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93934eae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cookieCutter" }
const _hoisted_2 = { class: "content bannerCont" }
const _hoisted_3 = { class: "descText" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("This website uses cookies. Change the ")
const _hoisted_5 = { class: "settingsTabs" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "introTab" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Manage Cookies"),
  /*#__PURE__*/_createElementVNode("p", null, "When you visit web sites, they may store or retrieve data in your web browser. This storage is often necessary for basic functionality of the web site or the storage may be used for the purposes of marketing, analytics, and personalization of the web site such as storing your preferences.")
], -1))
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["bannerView", {'visible':_ctx.viewState === 1}]),
      ref: "cookieBanner"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("strong", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openSettings && _ctx.openSettings(...args))),
            class: "textLink"
          }, "cookie preferences")
        ]),
        _createElementVNode("div", {
          class: "bannerLink",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refuseAll && _ctx.refuseAll(...args)))
        }, "Reject"),
        _createVNode(_component_base_button, {
          "btn-label": "Accept",
          onClick: _ctx.acceptAll
        }, null, 8, ["onClick"])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["settingsView", {'visible':_ctx.viewState === 2}]),
      ref: "cookieSettings"
    }, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (elm, ind) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "preferenceTab",
            key: ind
          }, [
            _createElementVNode("h4", null, _toDisplayString(elm.name), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["toggle", {'disabled':elm.required, 'active':elm.active}]),
              onClick: ($event: any) => (_ctx.toggle(ind))
            }, null, 10, _hoisted_7),
            _createElementVNode("p", null, _toDisplayString(elm.text), 1)
          ]))
        }), 128))
      ]),
      _createVNode(_component_base_button, {
        "btn-label": "Save",
        onClick: _ctx.saveSettings
      }, null, 8, ["onClick"])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["backgroundDark", {'visible':_ctx.viewState === 2}]),
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args)))
    }, null, 2)
  ]))
}